import React from 'react';

const Financeurs = () => {
    return (
        <div className="bandeau">

            <div className='financeurs'>
              
                  <img src="https://agorajobs.fr/reunion-pleniere-form/Assets/financeurs.PNG" alt="" />
               
            </div>
        </div>
    );
};

export default Financeurs;